import { render, staticRenderFns } from "./RequisitionCreateView.vue?vue&type=template&id=047e0905"
import script from "./RequisitionCreateView.vue?vue&type=script&lang=js"
export * from "./RequisitionCreateView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports